var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 24,
    height: 24,
    transform: "translate(46 111)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-46 -111)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "suitcase-rolling-solid",
    d: "M15.75,7.5H2.25A2.25,2.25,0,0,0,0,9.75v10.5A2.25,2.25,0,0,0,2.25,22.5H3v.75a.75.75,0,0,0,.75.75h1.5A.75.75,0,0,0,6,23.25V22.5h6v.75a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,.75-.75V22.5h.75A2.25,2.25,0,0,0,18,20.25V9.75A2.25,2.25,0,0,0,15.75,7.5ZM15,17.625a.375.375,0,0,1-.375.375H3.375A.375.375,0,0,1,3,17.625v-.75a.375.375,0,0,1,.375-.375h11.25a.375.375,0,0,1,.375.375Zm0-4.5a.375.375,0,0,1-.375.375H3.375A.375.375,0,0,1,3,13.125v-.75A.375.375,0,0,1,3.375,12h11.25a.375.375,0,0,1,.375.375ZM6.75,2.25h4.5V6H13.5V2.25A2.25,2.25,0,0,0,11.25,0H6.75A2.25,2.25,0,0,0,4.5,2.25V6H6.75Z",
    transform: "translate(49 111)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestLuggage);
export default __webpack_public_path__ + "static/media/request-luggage.630251d113f05bac4a8c9207635c32fb.svg";
export { ForwardRef as ReactComponent };